import api from "@/lib/api";

export function monthOptions(count = 12) {
  const out = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    out.push({
      value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`,
      label: d.toLocaleString("en", { month: "long", year: "numeric" }),
    });
  }
  return out;
}

export async function downloadStatement(year, month, extra = {}) {
  const params = new URLSearchParams();
  if (extra.type) params.set("type", extra.type);
  if (extra.user_id) params.set("user_id", extra.user_id);
  const qs = params.toString();
  const res = await api.get(
    `/statements/${year}/${String(month).padStart(2, "0")}.pdf${qs ? `?${qs}` : ""}`,
    { responseType: "blob" }
  );
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `interpreta-statement-${year}-${String(month).padStart(2, "0")}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
